import { Flex } from "@chakra-ui/react";
import AppraisalItem from "./AppraisalItem";

export default function AppraisalList({ list }) {
  return (
    <Flex
      align="start"
      border="1px solid #ccc"
      borderBottomRadius="0.5rem"
      w="100%"
      direction="column"
    >
      {list?.map((item, i) => (
        <AppraisalItem title="" path="invoicing" item={item} key={i} />
      ))}
    </Flex>
  );
}
